import { usePageCharts } from '~/api/hooks/useCharts'
import {
  useReviewPageState,
  useComparisonState,
  ReviewPageScaffold,
  PageTiles,
} from '~/components/ReviewPage'
import { PAGE_DEFAULTS } from '~/components/ReviewPage/pageDefaults'

export function ReviewKpis() {
  const state = useReviewPageState({
    pageId: 'ReviewKpis',
    factTable: 'media_national',
    defaultKpi: PAGE_DEFAULTS.ReviewKpis,
    archetype: 'status',
  })
  const compare = useComparisonState(state.fromIso, state.toIso)
  const charts = usePageCharts(state.pageId, state.kpi)
  return (
    <ReviewPageScaffold title="Review KPIs" state={state} compare={compare}>
      <PageTiles charts={charts} state={state} compare={compare} pageSlug="reviewkpis" />
    </ReviewPageScaffold>
  )
}
